import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useResourceDefinitions } from 'react-admin';
import { ResourceBreadcrumbItem } from './ResourceBreadcrumbItem';
/**
 * The <ResourceBreadcrumbItems /> component allows to render a bunch of <BreadcrumbItem /> from a list of resources
 * By default (without the "resources" props), it'll render all the react-admin registred resources
 *
 * Also exported as `Breadcrumb.ResourceItems` for convenience.
 *
 * @see BreadcrumbItem
 */
export var ResourceBreadcrumbItems = function (_a) {
    var selectedResources = _a.resources;
    var resourceDefinitions = useResourceDefinitions();
    var resources = Object.values(resourceDefinitions)
        .filter(function (resource) {
        return !selectedResources || selectedResources.includes(resource.name);
    })
        .map(function (resource) { return resource.name; });
    return (_jsx(_Fragment, { children: resources.map(function (name) { return (_jsx(ResourceBreadcrumbItem, { resource: name }, name)); }) }));
};
